module.exports = __webpack_public_path__ + "media/images/FFFalpha25-fbbbf4d2396b57f2f25904a6fdc42eed.png";